import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@web/base/shared/components/base/base.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';
import { checkForm, getCleanedString } from '@web/shared/utils';
import { IAttachment } from '../../attachment.model';
import { ConstantsProject } from '@web/project/shared/constants.class';

@Component({
  selector: 'web-edit-attachment',
  templateUrl: './edit-attachment.component.html',
  styleUrls: ['./edit-attachment.component.scss']
})
export class EditAttachmentComponent extends BaseComponent implements OnInit {

  public index: number;
  public formData: FormData;
  // public attachment: IAttachment;
  public attachments: Array<IAttachment>;
  public canActive = true;
  public acceptedFiles = '';

  public form: UntypedFormGroup;

  public fileUploaded;

  public maxSizeAttachment = ConstantsProject.MAX_SIZE_ATTACHMENTS;

  ATTACHMENT_TYPE_FILE = ConstantsProject.ATTACHMENT_TYPE_FILE;

  // public safeVideoUrl = null;
  // public videoImagePreview = null;

  constructor(
    public translate: TranslateService,
    // public sharedService: SharedService,
    // public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EditAttachmentComponent>) {
    super(translate);
  }

  ngOnInit() {

    this.createForm();

    if (this.index !== undefined && this.attachments[this.index]) {
      this.setForm(this.attachments[this.index]);
    }
  }

  close(val?) {
    // Si estamos creando y le damos a cancelar, eliminamos el archivo si lo hemos adjuntado.
    if (
      this.attachments[this.index] === undefined
      && this.formData.get('file_' + this.index)
    ) {
      this.formData.delete('file_' + this.index);
    }

    this.dialogRef.close(val);
  }

  createForm() {
    this.form = new UntypedFormGroup({
      attachmentID: new UntypedFormControl(null),
      type: new UntypedFormControl(this.ATTACHMENT_TYPE_FILE, [Validators.required]),
      title: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(125)]),
      hash: new UntypedFormControl(''),
      url: new UntypedFormControl(''),
      videoUrl: new UntypedFormControl(''),
      order: new UntypedFormControl(0),
      active: new UntypedFormControl(true),
    });

  }

  setForm(attachment: IAttachment) {
    Object.assign(attachment, { videoUrl: '' });
    this.form.patchValue(attachment);
  }

  onFile(file: any) {
    this.formData.delete('file_' + this.index);
    this.fileUploaded = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = ((e: any) => {
      // this.fileSelected = e.target.result;
      this.form.controls['url'].setValue(e.target.result);
    });

    this.formData.append('file_' + this.index, file, getCleanedString(file.name));
  }

  submit() {
    checkForm(this.form);

    if (
      this.form.valid
      && this.formData.get('file_' + this.index)
    ) {
      if (this.index !== undefined) {
        if (this.formData.has('file_' + this.index)) {
          this.formData.set('file_' + this.index, this.formData.get('file_' + this.index));
        } else {
          this.formData.append('file_' + this.index, this.formData.get('file_' + this.index));
        }

        this.attachments[this.index] = Object.assign({ pending: true }, this.form.value);
      } else {
        this.attachments.push(this.form.value);
        this.formData.append('file_' + this.index, this.formData.get('file_' + this.index));
      }

      this.close({ attachment: this.form.value, data: this.formData });
    }
  }
}
